<div class="container-fluid mt-3 ">

    <div class="row mt-3">
        <span class="ms-3 display-6 fw-bold">
            Véhicule
        </span>
    </div>
    <div class="row border rounded-1 background-light mb-3 py-3">
        <mat-form-field class="col-12">
            <mat-label>Plaque d'immatriculation</mat-label>
            <input matInput [(ngModel)]="Model.Vehicule.Plaque" placeholder="Plaque d'immatriculation">
        </mat-form-field>
        <mat-form-field class="col-12">
            <mat-label>Odomètre Début</mat-label>
            <input matInput type="number" [(ngModel)]="Model.Vehicule.OdometreDebut" placeholder="Odomètre Début">
        </mat-form-field>
        <mat-form-field class="col-12">
            <mat-label>Odomètre Fin</mat-label>
            <input matInput type="number" [(ngModel)]="Model.Vehicule.OdometreFin" placeholder="Odomètre Fin">
        </mat-form-field>
    </div>
    <div class="row mt-3">
        <span class="ms-3 display-6 fw-bold">
            Heure de pointage
        </span>
    </div>

    <div class="row border rounded-1 background-light mb-3 py-3">

        <mat-form-field class="col-12">
            <mat-label>Départ du domicile</mat-label>
            <input matInput placeholder="Départ du domicile" [ngxTimepicker]="timepicker1" [format]="24" [value]="TimeDepartDomicile" readonly>
            @if (TimeDepartDomicile) {
            <button matSuffix mat-icon-button aria-label="Clear" (click)="clearDepartDomicile()">
                <mat-icon class="material-symbols-outlined">close</mat-icon>
            </button>
            }
            <ngx-material-timepicker #timepicker1 (timeSet)="timeSetDepartDomicile($event)" [defaultTime]="DefaultTime"></ngx-material-timepicker>
        </mat-form-field>

        <mat-form-field class="col-12">
            <mat-label>Début de journée</mat-label>
            <input matInput placeholder="Début de journée" [ngxTimepicker]="timepicker3" [format]="24" [value]="TimeDebutJournee" readonly required>
            <ngx-material-timepicker #timepicker3 (timeSet)="timeSetDebutJournee($event)" [defaultTime]="DefaultTime"></ngx-material-timepicker>
        </mat-form-field>

        <mat-form-field class="col-12">
            <mat-label>Fin de journée</mat-label>
            <input matInput placeholder="Fin de journée" [ngxTimepicker]="timepicker4" [format]="24" [value]="TimeFinJournee" readonly required>
            <ngx-material-timepicker #timepicker4 (timeSet)="timeSetFinJournee($event)" [defaultTime]="DefaultTime"></ngx-material-timepicker>
        </mat-form-field>

        <mat-form-field class="col-12">
            <mat-label>Arrivée au domicile</mat-label>
            <input matInput placeholder="Arrivée au domicile" [ngxTimepicker]="timepicker2" [format]="24" [value]="TimeArriveeDomicile" readonly>
            @if (TimeArriveeDomicile) {
            <button matSuffix mat-icon-button aria-label="Clear" (click)="clearArriveeDomicile()">
                <mat-icon class="material-symbols-outlined">close</mat-icon>
            </button>
            }
            <ngx-material-timepicker #timepicker2 (timeSet)="timeSetArriveeDomicile($event)" [defaultTime]="DefaultTime"></ngx-material-timepicker>
        </mat-form-field>

    </div>

    <div class="row">
        <span class="ms-3 display-6 fw-bold">
            Liste des pauses
        </span>
    </div>
    <div class="row border rounded-1 background-light mb-3 py-3">
        @for (p of Model.PointagePauseList; track p) {
        <div class="g-0 row justify-content-between">
            <span class="col-1"></span>
            <span class="col-auto">{{p.Debut.toLocaleString(undefined, { hour: 'numeric', minute: 'numeric' })}} - {{p.Fin.toLocaleString(undefined, { hour: 'numeric', minute: 'numeric' })}}</span>
            <a class="col-auto btn-close" (click)="deletePause(p)"></a>
        </div>
        }
        <div class="row justify-content-center">
            <button class="col-auto" color="accent" mat-raised-button (click)="openPauseDialog()">
                Ajouter une pause
            </button>
        </div>
    </div>
    <div class="row mt-3">
        <button appPreventDoubleClick lass="col-12" color="primary" mat-raised-button (throttledClick)="save()">
            Enregistrer le pointage
        </button>
    </div>
</div>